export default "__VITE_PUBLIC_ASSET__7ac19fe6__"